//-------------------------------------------------------------------------------------------------- Imports
import { Button, Typography, Modal } from "antd";
import { StyleSheet } from "../StyleSheet";
import "./css/alertModal.css";
import ReceiptPayment from "./ReceiptPayment";
import { useNavigate } from "react-router-dom";
import stylesCss from "./css/alertModal.module.css";
const { Text } = Typography;

export interface PaymentData {
    amount: string;
    concept: string;
    date: string;
    time: string;
    name: string;
    client: string;
    idTransaction?: string;
    card: string;
};

type Props = {
    title: string,
    message?: string,
    isReceiptPayment?: boolean;
    show: boolean;
    paymentData?: PaymentData;
    onClose?: () => void;
};

//-------------------------------------------------------------------------------------------------- Component
const AlertModal = (props: Props) => {
    const { show, title, message, paymentData, isReceiptPayment, onClose } = props;
    const navigate = useNavigate();

    const onClick = () => {
        if (onClose) {
            onClose();
            return;
        }
        navigate("/");
    };

    return ((show) ? (
        <Modal
            centered
            open={show}
            title={title}
            closable={false}
            classNames={{
                header: stylesCss.modalWidth,
                body: stylesCss.modalWidth,
                content: stylesCss.modalWidth,
                footer: stylesCss.modalWidth,
            }}
            footer={
                <Button
                    type={"primary"}
                    shape='round'
                    style={{ color: "#007aff", height: 35, width: 120, marginRight: 10 }}
                    onClick={() => onClick()}
                >
                    <Text style={{ color: 'white', fontSize: 13 }}>
                        {"CERRAR"}
                    </Text>
                </Button>
            }
        >
            {
                isReceiptPayment && paymentData ?
                    <ReceiptPayment paymentData={paymentData} />
                    :
                    <div style={{ padding: "20px 24px" }}>
                        <Text style={styles.messageTextStyle}>
                            {message ? message : ""}
                        </Text>
                    </div>
            }
        </Modal>
    ) : (
        null
    ));
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    lineDivider: {
        backgroundColor: '#d6d6d6',
        margin: 0,
    },
    mainContainer: {
        margin: "40px 10px 30px 10px",
        padding: 0
    },
    iconStyle: {
        fontSize: 50,
    },
    messageTextStyle: {
        fontSize: 14,
    },
    divAlert: {
        width: "100%",
        height: "100%",
        borderTop: "1px solid #b0b0b0"
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default AlertModal;
